module.exports = __webpack_public_path__ + "dec9a160497aa68cc33318027dcb162f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Description/images/web2_3x.png
// module id = HP0S
// module chunks = 13